var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudent35(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#494648",
    opacity: 1,
    d: "M322.81+240.493L296.966+377.399C283.652+429.791+316.014+481.895+354.654+482.183L671.22+483.085C709.859+483.372+747.964+432.723+736.341+379.498L711.805+246.805"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    d: ""
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#f7a9b0",
    d: "M876.999+915.886L183.402+915.886C165.861+915.886+152.367+901.685+153.262+884.167L167.853+598.697C167.853+527.055+232.424+483.214+281.359+478.515L413.788+469.661L622.622+469.234L747.281+478.515C808.61+483.214+860.787+527.055+860.787+598.697L876.999+915.886Z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#ffe5c0",
    d: "M511.722+110.569L519.278+110.569C617.868+110.569+697.791+196.81+697.791+303.194L697.791+303.194C697.791+409.578+617.868+495.819+519.278+495.819L511.722+495.819C413.131+495.819+333.208+409.578+333.208+303.194L333.208+303.194C333.208+196.81+413.131+110.569+511.722+110.569Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe5c0",
    d: "M513.641+350.256L518.054+350.256C575.632+350.256+622.309+400.324+622.309+462.085L622.309+462.085C622.309+523.847+575.632+573.914+518.054+573.914L513.641+573.914C456.062+573.914+409.386+523.847+409.386+462.085L409.386+462.085C409.386+400.324+456.062+350.256+513.641+350.256Z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.804+55.2155C603.552+49.8189+699.649+133.578+716.642+254.715C716.703+269.965+709.72+270.326+692.453+268.448C661.251+265.054+616.273+261.318+572.566+256C562.004+254.715+555.707+158.224+555.707+158.224C555.707+158.224+559.104+250.407+552.477+254.441C536.867+263.943+469.487+253.165+458.572+254.149C450.376+254.888+458.302+154.9+458.302+154.9C458.302+154.9+448.701+252.757+441.444+253.502C410.022+256.729+316.451+269.737+319.063+251.956C336.546+132.963+416.345+60.9517+512.804+55.2155Z",
    opacity: 1,
    fill: "#494648"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent35);
export default __webpack_public_path__ + "static/media/Student 35.8a9b605c219a21124130ded01c6f2122.svg";
export { ForwardRef as ReactComponent };